import React from 'react';
import { AlertIcon } from 'assets/img';
import { Modal } from 'components';

interface Props {
  visible: boolean
  onClose: () => void
}

const DisclaimerModal = ({ visible, onClose }: Props) => (
  <Modal
    className="modal-disclaimer"
    withoutClose
    visible={visible}
    onClose={onClose}
  >
    <div className="card">
      <img src={AlertIcon} className="alert-icon" alt="Alerta" />
      <p className="subtitle">
        <span className="bold">No reconocemos</span> ningún pago hecho directo a vendedores, ni a otra cuenta que no sea las mostradas en esta APP
      </p>
      <div className="actions">
        <button onClick={onClose}>CONTINUAR</button>
      </div>
    </div>
  </Modal>
)

export default DisclaimerModal